/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const DeleteApiKeyBudgetQueryParamOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteApiKeyBudgetQueryParamOwner = ClosedEnum<
  typeof DeleteApiKeyBudgetQueryParamOwner
>;

export type DeleteApiKeyBudgetRequest = {
  apiKeyId: string;
  owner: DeleteApiKeyBudgetQueryParamOwner;
};

export const DeleteApiKeyBudgetScope = {
  Org: "org",
  Apikey: "apikey",
  User: "user",
  Team: "team",
  ExternalUser: "external_user",
  UserDefault: "user_default",
  TeamDefault: "team_default",
  ExternalUserDefault: "external_user_default",
} as const;
export type DeleteApiKeyBudgetScope = ClosedEnum<
  typeof DeleteApiKeyBudgetScope
>;

export const DeleteApiKeyBudgetOwner = {
  Cluster: "cluster",
  Org: "org",
} as const;
export type DeleteApiKeyBudgetOwner = ClosedEnum<
  typeof DeleteApiKeyBudgetOwner
>;

/**
 * OK
 */
export type DeleteApiKeyBudgetResponseBody = {
  scope: DeleteApiKeyBudgetScope;
  scopeId: string;
  owner: DeleteApiKeyBudgetOwner;
  deleted: true;
};

/** @internal */
export const DeleteApiKeyBudgetQueryParamOwner$inboundSchema: z.ZodNativeEnum<
  typeof DeleteApiKeyBudgetQueryParamOwner
> = z.nativeEnum(DeleteApiKeyBudgetQueryParamOwner);
/** @internal */
export const DeleteApiKeyBudgetQueryParamOwner$outboundSchema: z.ZodNativeEnum<
  typeof DeleteApiKeyBudgetQueryParamOwner
> = DeleteApiKeyBudgetQueryParamOwner$inboundSchema;

/** @internal */
export const DeleteApiKeyBudgetRequest$inboundSchema: z.ZodType<
  DeleteApiKeyBudgetRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  apiKeyId: z.string(),
  owner: DeleteApiKeyBudgetQueryParamOwner$inboundSchema,
});
/** @internal */
export type DeleteApiKeyBudgetRequest$Outbound = {
  apiKeyId: string;
  owner: string;
};

/** @internal */
export const DeleteApiKeyBudgetRequest$outboundSchema: z.ZodType<
  DeleteApiKeyBudgetRequest$Outbound,
  z.ZodTypeDef,
  DeleteApiKeyBudgetRequest
> = z.object({
  apiKeyId: z.string(),
  owner: DeleteApiKeyBudgetQueryParamOwner$outboundSchema,
});

export function deleteApiKeyBudgetRequestToJSON(
  deleteApiKeyBudgetRequest: DeleteApiKeyBudgetRequest,
): string {
  return JSON.stringify(
    DeleteApiKeyBudgetRequest$outboundSchema.parse(deleteApiKeyBudgetRequest),
  );
}
export function deleteApiKeyBudgetRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteApiKeyBudgetRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteApiKeyBudgetRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteApiKeyBudgetRequest' from JSON`,
  );
}

/** @internal */
export const DeleteApiKeyBudgetScope$inboundSchema: z.ZodNativeEnum<
  typeof DeleteApiKeyBudgetScope
> = z.nativeEnum(DeleteApiKeyBudgetScope);
/** @internal */
export const DeleteApiKeyBudgetScope$outboundSchema: z.ZodNativeEnum<
  typeof DeleteApiKeyBudgetScope
> = DeleteApiKeyBudgetScope$inboundSchema;

/** @internal */
export const DeleteApiKeyBudgetOwner$inboundSchema: z.ZodNativeEnum<
  typeof DeleteApiKeyBudgetOwner
> = z.nativeEnum(DeleteApiKeyBudgetOwner);
/** @internal */
export const DeleteApiKeyBudgetOwner$outboundSchema: z.ZodNativeEnum<
  typeof DeleteApiKeyBudgetOwner
> = DeleteApiKeyBudgetOwner$inboundSchema;

/** @internal */
export const DeleteApiKeyBudgetResponseBody$inboundSchema: z.ZodType<
  DeleteApiKeyBudgetResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  scope: DeleteApiKeyBudgetScope$inboundSchema,
  scope_id: z.string(),
  owner: DeleteApiKeyBudgetOwner$inboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    "scope_id": "scopeId",
  });
});
/** @internal */
export type DeleteApiKeyBudgetResponseBody$Outbound = {
  scope: string;
  scope_id: string;
  owner: string;
  deleted: true;
};

/** @internal */
export const DeleteApiKeyBudgetResponseBody$outboundSchema: z.ZodType<
  DeleteApiKeyBudgetResponseBody$Outbound,
  z.ZodTypeDef,
  DeleteApiKeyBudgetResponseBody
> = z.object({
  scope: DeleteApiKeyBudgetScope$outboundSchema,
  scopeId: z.string(),
  owner: DeleteApiKeyBudgetOwner$outboundSchema,
  deleted: z.literal(true),
}).transform((v) => {
  return remap$(v, {
    scopeId: "scope_id",
  });
});

export function deleteApiKeyBudgetResponseBodyToJSON(
  deleteApiKeyBudgetResponseBody: DeleteApiKeyBudgetResponseBody,
): string {
  return JSON.stringify(
    DeleteApiKeyBudgetResponseBody$outboundSchema.parse(
      deleteApiKeyBudgetResponseBody,
    ),
  );
}
export function deleteApiKeyBudgetResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<DeleteApiKeyBudgetResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteApiKeyBudgetResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteApiKeyBudgetResponseBody' from JSON`,
  );
}
